// extracted by mini-css-extract-plugin
export default {"TittleSection":"selectBox_TittleSection__JWskU","SelectBoxSection":"selectBox_SelectBoxSection__k1K9F","SelectBoxSectionFrame":"selectBox_SelectBoxSectionFrame__hVIfi"};